import { expressQuerySelector, expressEventListener } from "../../common/html";
import { CreateNavigationDesktopFirstLevel } from "../molecules/navigation-desktop-first-level";
import { CreateNavigationDesktopSecondLevel } from "../molecules/navigation-desktop-second-level";
import {
	CreateNavigationDesktopThirdLevel,
	INavigationDesktopThirdLevelSideContainerDeps,
} from "../molecules/navigation-desktop-third-level";

export function CreateNavigationDesktop(container: HTMLElement) {
	const HIDE_CLASS = "u-hide";
	const OVERLAY_THIRD_LEVEL_CLASS = "o-navigation-desktop__overlay--full-width";
	const firstLevel = expressQuerySelector<HTMLElement>(container, ".technical-navigation-first-level");
	const secondLevel = expressQuerySelector<HTMLElement>(container, ".technical-navigation-second-level");
	const thirdLevel = expressQuerySelector<HTMLElement>(container, ".technical-navigation-thrid-level");
	const navigationOverlay = expressQuerySelector<HTMLElement>(container, ".technical-navigation-overlay");
	const navigationBackdrop = expressQuerySelector<HTMLElement>(container, ".technical-navigation-backdrop");

	const secondLevelComponent = CreateNavigationDesktopSecondLevel(secondLevel, {
		activatedElement: (el: HTMLElement) => toggleThirdLevelMenu(el),
		getActiveIndex: () => {
			return firstLevelActiveIndex;
		},
	});
	const firstLevelComponent = CreateNavigationDesktopFirstLevel(firstLevel, {
		activatedElement: (el: HTMLElement) => toggleSecondLevelMenu(el),
		getActiveIndex: () => {
			return -1;
		}, // 0 level never active
	});

	const thridLevelComponent = CreateNavigationDesktopThirdLevel(thirdLevel, {
		activatedElement: (el: HTMLElement) => {
			return; // does not use deeper levels
		},
		getActiveIndex: () => {
			return secondLevelActiveIndex;
		},
	});

	let firstLevelActiveIndex = -1;
	let secondLevelActiveIndex = -1;
	const toggleSecondLevelMenu = (el: HTMLElement) => {
		navigationOverlay.classList.toggle(OVERLAY_THIRD_LEVEL_CLASS, false);

		if (!el?.dataset.menuItem || el.dataset.hasSecondLevel === "false") {
			navigationOverlay.style.left = "";
			navigationOverlay.classList.add(HIDE_CLASS);
			secondLevelComponent.close();
			thridLevelComponent.close();
			firstLevelActiveIndex = -1;
			return;
		}

		firstLevelActiveIndex = parseInt(el.dataset.menuItem, 10);
		secondLevelComponent.open(firstLevelActiveIndex);
		thridLevelComponent.close();
		navigationOverlay.classList.remove(HIDE_CLASS);
		navigationOverlay.style.left = `${el.getBoundingClientRect().left - container.getBoundingClientRect().left}px`;
	};

	const toggleThirdLevelMenu = (el: HTMLElement) => {
		navigationOverlay.classList.toggle(OVERLAY_THIRD_LEVEL_CLASS, el && el.dataset.hasThirdLevel === "true");

		if (!el?.dataset.menuItem || firstLevelActiveIndex < 0 || el.dataset.hasThirdLevel === "false") {
			thridLevelComponent.close();
			return;
		}

		secondLevelActiveIndex = parseInt(el.dataset.menuItem, 10);
		const sideContainerDeps = {
			title: el.dataset.name,
			link: el.dataset.link,
			imageUrl: el.dataset.imageUrl,
		} as INavigationDesktopThirdLevelSideContainerDeps;

		thridLevelComponent.open(firstLevelActiveIndex, secondLevelActiveIndex, sideContainerDeps);
	};
	const containerDisposible = expressEventListener(container, "mouseleave", () => {
		toggleSecondLevelMenu(null);
		toggleThirdLevelMenu(null);
	});

	const navigationBackdropDisposible = expressEventListener(navigationBackdrop, "click", () => {
		toggleSecondLevelMenu(null);
		toggleThirdLevelMenu(null);
	});

	return {
		dispose: () => {
			containerDisposible.dispose();
			navigationBackdropDisposible.dispose();
			firstLevelComponent.dispose();
			secondLevelComponent.dispose();
			thridLevelComponent.dispose();
		},
	};
}
